/**
 * Created by untitled on 13/03/2017.
 */

const React = require('react');
const PropTypes = require('prop-types');
const Relay = require('react-relay');
const get = require('lodash.get');
const ContextComponent = require('../../../global/components/ContextComponent');
const { CallDealerModal } = require('dibs-buyer-initiate-call');
const authModalLoader = require('../../../auth/authModalLoader').default;
const favoriteActions = require('../../../global/actions/favoritesActions');
const FavoriteModel = require('bunsen/models/identity/Favorite');
const PhoneIcon = require('dibs-vg/dist/react/phone');

class CallDealerButton extends ContextComponent {
    constructor(props) {
        super(props);
        this.state = { callDealerIsOpened: false };
        this.onCallDealerClick = this.onCallDealerClick.bind(this);
        this.onCallDealerModalClose = this.onCallDealerModalClose.bind(this);
        this.onCallDealerAuthRequired = this.onCallDealerAuthRequired.bind(this);
        this.onCallDealerModalFollow = this.onCallDealerModalFollow.bind(this);
    }

    onCallDealerClick() {
        const { callDealerIsOpened } = this.state;
        this.setState({ callDealerIsOpened: !callDealerIsOpened });
    }

    onCallDealerModalClose() {
        this.setState({ callDealerIsOpened: false });
    }

    onCallDealerAuthRequired(onAuthSuccess, onAuthFailure) {
        this.setState({ callDealerIsOpened: false });
        authModalLoader.show({
            action: authModalLoader.constants.REGISTER,
            flow: authModalLoader.constants.CONTACT_DEALER_CALL_FLOW
        }).then(({ user, err }) => {
            if (err) {
                onAuthFailure();
                return;
            }
            onAuthSuccess(user.userId);
            this.setState({ callDealerIsOpened: true });
        });
    }

    onCallDealerModalFollow() {
        const { dealerPk, page } = this.props;
        const payload = {
            type: FavoriteModel.TYPE_DEALER,
            primaryKey: dealerPk,
            page
        };
        this.context.executeAction(favoriteActions.saveToFavorites, payload);
        this.setState({ callDealerIsOpened: false });
    }

    render() {
        const { callDealerIsOpened } = this.state;
        const { userId, hasUserId, viewer, item, copy } = this.props;
        const callDealerCtaCopy = get(copy, 'dealer.callDealerCta');

        return (
            <div>
                <a href="#" className="pdp-call-dealer-wrapper" onClick={this.onCallDealerClick}>
                    <PhoneIcon className="pdp-call-dealer-icon" />
                    <span className="pdp-call-dealer-copy">{callDealerCtaCopy}</span>
                </a>

                <CallDealerModal
                    userId={userId}
                    hasUserId={hasUserId}
                    viewer={viewer}
                    item={item}
                    isOpened={callDealerIsOpened}
                    location="pdp"
                    onAuthRequired={this.onCallDealerAuthRequired}
                    onClose={this.onCallDealerModalClose}
                    onFollowDealer={this.onCallDealerModalFollow}
                />
            </div>
        );
    }
}

CallDealerButton.propTypes = {
    userId: PropTypes.string,
    hasUserId: PropTypes.bool.isRequired,
    dealerPk: PropTypes.string.isRequired,
    page: PropTypes.string.isRequired,
    copy: PropTypes.object.isRequired,
    viewer: PropTypes.object,
    item: PropTypes.object
};

module.exports = Relay.createContainer(CallDealerButton, {
    initialVariables: {
        userId: null,
        hasUserId: false
    },
    fragments: {
        item: ({ userId, hasUserId }) => Relay.QL`
            fragment on Item {
                ${CallDealerModal.getFragment('item', { userId, hasUserId })}
            }
        `,
        viewer: ({ userId, hasUserId }) => Relay.QL`
            fragment on Viewer {
                ${CallDealerModal.getFragment('viewer', { userId, hasUserId })}
            }
        `
    }
});



// WEBPACK FOOTER //
// ./assets/js/newPdp/components/ContactDealer/CallDealerButton.jsx